type FrontendItem = {
  name?: string;
  sku?: string;
};

export function getTrustpilotProductSkus(frontItems: FrontendItem[]) {
  const items = frontItems.map((item) => {
    const sizeSkus = item?.name?.split("x") || [""];
    return (
      item.sku?.slice(0, 6) +
      (sizeSkus?.length === 2
        ? sizeSkus[1] + " " + sizeSkus[0].padStart(4, "0")
        : sizeSkus[0])
    );
  });
  return items.sort((a, b) => a.localeCompare(b));
}
